import { Col, Row } from 'antd';
import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

function Footer(props) {
  return (
    <footer id='footerbox' style={{ overflowX: 'hidden' }}>
      <div className="container footer" style={{ width: "100%", maxWidth: "100vw", overflowX: "hidden" }}>
        
        <div className="row footerdiv">
          <Row gutter={[16, 16]}>

            <Col md={12} xs={24} sm={24}>
              <h2>Flipkart Ads
              </h2>
              <p style={{fontWeight:'lighter'}}>
                Flipkart Ads is a dynamic advertising platform that taps into the power of India’s leading online marketplace, reaching over 500 million users across 19,000+ pin codes. Its diverse ad formats and solutions enable brands to connect with consumers at every stage of the purchase journey – from creating awareness to influencing consideration and driving purchases.
              </p>
              <p style={{fontWeight:'lighter'}}>Backed by deep insights, extensive reach, and real-time analytics, Flipkart Ads empowers brands to optimise campaigns and achieve impactful results through effective measurement and continuous optimisation.</p>
            </Col>
            <Col md={12} xs={24} sm={24}>
              <h2>Flipkart Connect</h2>
              <p style={{fontWeight:'lighter'}}>
                Flipkart Connect is our flagship annual conclave celebrating the power of e-commerce, retail, and innovation. It brings together top industry leaders, advertisers, and brands and is a platform to explore cutting-edge trends, share actionable insights, and recognise groundbreaking campaigns that have made a real impact.
              </p>
              <p style={{fontWeight:'lighter'}}>
                From engaging sessions with marketing maestros to networking opportunities with industry pioneers, Flipkart Connect is your chance to learn, connect, and get inspired. Be a part of the future of e-commerce marketing with Flipkart Connect!              </p>
            </Col>
            <Col span={24}>
              <div className="social" style={{ textAlign: "center", marginTop: "20px" }}>
                <ul style={{ listStyle: "none", padding: 0, display: "flex", justifyContent: "center", gap: "15px" }}>
                  {/* <li>
                    <a target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/FlipkartAds/">
                      <i className="fa fa-brands fa-facebook"></i>
                    </a>
                  </li> */}
                  {/* <li>
                    <a target='_blank' rel="noopener noreferrer" href="https://www.linkedin.com/showcase/flipkart-ads/">
                      <i className="fa fa-brands fa-linkedin"></i>
                    </a>
                  </li> */}
                  {/* <li>
                    <a target='_blank' rel="noopener noreferrer" href="https://twitter.com/flipkartads">
                      <i className="fa fa-brands fa-x-twitter"></i>
                    </a>
                  </li> */}
                  {/* <li>
                    <a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/channel/UCWZc94oeti-YQsI9995G3aA">
                      <i className="fa fa-brands fa-youtube"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
        {/* <div className='row'>
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <ScrollAnimation animateIn="fadeIn">
              <div className="row footerdiv">

                <h2>ABOUT FLIPKART ADS</h2>
                <p>
                  Flipkart Ads, a dynamic advertising platform, leverages the power of India's top online marketplace, connecting brands with a vast audience of over 500 million users across ~99% pin-code of India. Offering diverse ad formats, it caters to varied brand objectives and customer preferences throughout the entire purchase journey. From creating awareness to influencing consideration and purchase, Flipkart Ads empowers brands with rich insights and real-time analytics for effective campaign measurement and optimization.                </p>

                <div className="social" style={{ textAlign: "center", marginTop: "20px" }}>
                  <ul style={{ listStyle: "none", padding: 0, display: "flex", justifyContent: "center", gap: "15px" }}>
                    <li>
                      <a target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/FlipkartAds/">
                        <i className="fa fa-brands fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a target='_blank' rel="noopener noreferrer" href="https://twitter.com/flipkartads">
                        <i className="fa fa-brands fa-x-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/channel/UCWZc94oeti-YQsI9995G3aA">
                        <i className="fa fa-brands fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </ScrollAnimation>
          </div>
          <div className="col-md-2"></div>
        </div> */}
        <div id="footer">
        <div className="container text-center">
          <p>Copyright © Flipkart</p>
        </div>
      </div>
      </div>

      {/* Footer Section */}
      
    </footer >
  );
}

export default Footer;
